<script>
import {
  BANOBAGI_RIGHT_DEFINITIONS,
  BANOBAGI_RIGHT_TYPES
} from "@/utils/banobagiRights";

export default {
  name: "BanobagiStatsGrid",
  props: {
    summary: {
      type: Object,
      default: () => ({})
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  emits: ["open-transaction"],
  computed: {
    items() {
      return [
        {
          key: "point",
          rightKey: BANOBAGI_RIGHT_TYPES.SUPER_SYNC_ZONE
        },
        {
          key: "coupon",
          rightKey: BANOBAGI_RIGHT_TYPES.WATSONS_EXCLUSIVE
        },
        {
          key: "reward",
          rightKey: BANOBAGI_RIGHT_TYPES.SYNC_ZONE
        }
      ].map(item => {
        const definition = BANOBAGI_RIGHT_DEFINITIONS.find(
          candidate => candidate.key === item.rightKey
        );
        return {
          ...item,
          label: definition?.label || item.rightKey,
          labelLines: definition?.labelLines || [item.rightKey],
          value: this.summary[item.rightKey] ?? 0
        };
      });
    }
  },
  methods: {
    displayValue(value) {
      if (this.isLoading) return "…";
      if (this.hasError) return "-";
      return this.numeralFormat(value);
    }
  }
};
</script>

<template>
  <section class="banobagi-stats" data-test="profile-stats-list">
    <button
      v-for="item in items"
      :key="item.key"
      type="button"
      :class="['banobagi-stats__card', `is-${item.key}`]"
      :data-test="`profile-stats-${item.key}-btn`"
      :aria-label="
        $t('transaction_header') +
        ': ' +
        item.label +
        ': ' +
        displayValue(item.value)
      "
      @click="$emit('open-transaction', item)"
    >
      <span
        class="banobagi-stats__label"
        :data-test="`profile-stats-${item.key}-label`"
      >
        <span v-for="line in item.labelLines" :key="line">{{ line }}</span>
      </span>
      <span
        class="banobagi-stats__value"
        :data-test="`profile-stats-${item.key}-value`"
      >
        {{ displayValue(item.value) }}
      </span>
    </button>
  </section>
</template>

<style lang="scss" scoped>
.banobagi-stats {
  position: relative;
  z-index: 1;

  gap: 16px;
  margin: 32px 16px 0;
  display: flex;
  flex-direction: column;
}

.banobagi-stats__card {
  position: relative;
  display: flex;
  min-width: 0;
  // min-height: 180px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  overflow: hidden;
  padding: 0 24px;
  min-height: 58px;
  border: 1px solid var(--secondary-color-light);
  border-radius: 26px;
  color: var(--text-color);
  box-shadow: 0 12px 25px rgba(111, 86, 120, 0.13);
  cursor: pointer;
  font: inherit;
  text-align: left;
  border: 1px solid rgb(255 255 255 / 50%);
}

.banobagi-stats__card:focus-visible {
  outline: 3px solid var(--primary-color);
  outline-offset: 3px;
}

.banobagi-stats__card.is-point {
  background: linear-gradient(160deg, #ded2ff 0%, #cfc1f6 100%);
  color: #8c6cf0;
}

.banobagi-stats__card.is-coupon {
  background: linear-gradient(160deg, #e5e7ff 0%, #d8ddfa 100%);
  color: #708bd8;
}

.banobagi-stats__card.is-reward {
  background: linear-gradient(160deg, #e1f1f9 0%, #cee8f3 100%);
  color: #5ca7dc;
}

.banobagi-stats__label {
  overflow: hidden;
  max-width: 100%;
  font-size: var(--font-title-sm);
  font-weight: 600;
  line-height: 1.35;
}

.banobagi-stats__label span {
  display: block;
}

.banobagi-stats__value {
  color: #7863ef;
  font-size: var(--font-heading);
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.banobagi-stats__card.is-coupon .banobagi-stats__value {
  color: #7395e8;
}

.banobagi-stats__card.is-reward .banobagi-stats__value {
  color: #45a9da;
}

@media (max-width: 360px) {
  .banobagi-stats {
    gap: 8px;
    margin-right: 12px;
    margin-left: 12px;
  }

  .banobagi-stats__card {
    min-height: 158px;
    padding-right: 8px;
    padding-left: 8px;
    border-radius: 22px;
  }

  .banobagi-stats__label {
    font-size: var(--font-body-lg);
  }
}
</style>
